var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNonAscii)?_c('v-alert',{staticClass:"mt-1",attrs:{"type":"warning"}},[_vm._v("\n  Non-ASCII characters are detected in the above JSON. If this is not intentional, make sure to check the text for homoglyphs.\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }